import React from "react";
import { toImageSrc } from "../../utils/ecommerce/svg-image-src";
import { isSvgMarkup } from "../../utils/image/image-file-utils";

export default function ImagePreviewRemove({ value, alt, onRemove, disabled = false, removeLabel }) {
    if (!value) return null;

    const isSvg = isSvgMarkup(value);

    return (
        <div className="relative mt-3 overflow-hidden rounded-2xl border border-slate-200 bg-slate-50">
            <div className="aspect-video w-full flex items-center justify-center p-4">
                {isSvg ? (
                    <div
                        className="max-h-full max-w-full [&>svg]:max-h-48 [&>svg]:max-w-full"
                        dangerouslySetInnerHTML={{ __html: value }}
                    />
                ) : (
                    <img
                        src={toImageSrc(value)}
                        alt={alt}
                        className="max-h-48 w-full object-contain"
                    />
                )}
            </div>
            <button
                type="button"
                onClick={onRemove}
                disabled={disabled}
                className="absolute top-3 right-3 rounded-lg bg-white/95 px-3 py-1.5 text-sm font-semibold text-red-600 shadow-md border border-red-100 hover:bg-red-50 disabled:opacity-50"
            >
                {removeLabel}
            </button>
        </div>
    );
}
